<template>
  <Teleport to="body">
    <aside class="aside">
      <swiper
        :slidesPerView="'auto'"
        :initialSlide="0"
        :pagination="pagination"
        :modules="modules"
        class="bannerSwiper"
        :loop="true"
        :autoplay="{
          delay: 2500,
        }"
      >
        <swiper-slide v-for="banner in bannerList" :key="banner">
          <a :href="banner.url" traget="_blank">
            <img :src="require(`@/assets/banner/${banner.img}`)" :alt="banner.alt" />
          </a>
        </swiper-slide>
      </swiper>
      <div class="banner_pagination"></div>
    </aside>
  </Teleport>
</template>

<script>
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";

export default {
  name: "SideBanner",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {},
  data() {
    return {
      bannerList: [
        {
          url: "https://store.onstove.com/ko/games/3957",
          img: "banner_promotion_2507.png",
          alt: "스토브 퍼즐 & 캐주얼 파티",
        },
        {
          url: "#",
          img: "banner_comicworld2025.png",
          alt: "코믹월드 2025",
        },
        {
          url: "https://store.onstove.com/ko/games/3957",
          img: "banner_earlyaccess_pc.png",
          alt: "PC 확장판 얼리엑세스 런칭",
        },
        {
          url: "https://sonaksdp.com/link/",
          img: "banner_snake_update.png",
          alt: "푸른 뱀의 해 업데이트 안내",
        },
      ],
      cardNumber: 4,
    };
  },
  methods: {},
  setup() {
    return {
      pagination: {
        el: ".banner_pagination",
      },
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>

<style scoped>
.aside {
  position: fixed;
  right: 4rem;
  top: 50%;
  z-index: 900;

  width: 16rem;
  width: 20rem;
  max-height: 60%;
  transform: translateY(-50%);
  transition: opacity 1s;
  opacity: 1;
}
.aside.fade {
  opacity: 0;
}
.aside .banner_pagination {
  display: flex;
  justify-content: center;
  padding: 16px 0;
}
@media all and (max-width: 1620px) {
  .aside {
    display: none;
  }
}
</style>
<style>
.aside .banner_pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  margin: 0 4px;
}
.aside .banner_pagination .swiper-pagination-bullet-active {
  background-color: var(--color-dark);
}
</style>
